// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".news-image{height:13rem !important}.recentNews-image{height:2rem !important}\n", "",{"version":3,"sources":["/app/src/component/specific/profile/RcentNewsCard/recentNewsCard.scss"],"names":[],"mappings":"AAAA,YACE,uBAAwB,CACzB,kBAGG,sBAAuB","file":"recentNewsCard.scss","sourcesContent":[".news-image {\n  height: 13rem !important;\n}\n\n.recentNews-image{\n    height: 2rem !important;\n}\n"]}]);
// Exports
module.exports = exports;
